<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P00045.installation.link.connexion' | translate"
      [description]="
        'P00045.installation.link.connexion.description' | translate
      "
    >
    </app-header-configuration>

    @if (currentForm) {
      <form [formGroup]="currentForm">
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <ion-input
                [placeholder]="'P00045.installation.link.reseau' | translate"
                class="required"
                label="{{ 'P00045.installation.link.identifiant' | translate }}"
                labelPlacement="stacked"
                formControlName="ssid"
                mode="ios"
              ></ion-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <ion-input
                placeholder=""
                class="required"
                label="{{ 'P00045.installation.link.mdp' | translate }}"
                labelPlacement="stacked"
                formControlName="password"
                mode="ios"
              ></ion-input>
            </div>
          </div>
        </div>
      </form>
    }

    <app-label-description
      [description]="'P00045.installation.link.connect1' | translate"
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
